import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2fda9ae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar close" }
const _hoisted_2 = { class: "image-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/africapos.png",
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text logo-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "name" }, "Africapos")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right toggle" }, null, -1))
const _hoisted_6 = { class: "menu-bar" }
const _hoisted_7 = { class: "menu" }
const _hoisted_8 = { class: "menu-links" }
const _hoisted_9 = { class: "text nav-text" }
const _hoisted_10 = { class: "home" }
const _hoisted_11 = { class: "p-p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_HomeFooter = _resolveComponent("HomeFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("header", null, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/documentation",
            class: "image"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _hoisted_4
        ]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (m, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "nav-link"
              }, [
                _createVNode(_component_router_link, {
                  exact: "",
                  "exact-active-class": "bg-primary",
                  to: `/documentation/${m}`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(`icon ${_ctx.featureIcons[m]}`)
                    }, null, 2),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(`workspaceLayout.${m}`)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(_component_HomeFooter)
    ])
  ], 64))
}